export default () => ({
	legacy: false,
	// Fallback chains per locale so untranslated keys don't collapse straight to
	// Spanish. Italian borrows from English first (closer Latin-script tech
	// vocabulary), Portuguese from Spanish. Any locale not listed falls back to
	// Spanish, the source-of-truth locale.
	fallbackLocale: {
		it: ["en", "es"],
		pt: ["es"],
		default: ["es"]
	}
});
